/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react'

import './dashboard.scss'

import Menu from '../../../components/CustomerClub/Menu'

import qr from '../../../assets/svg/qr.svg'
import campaign from '../../../assets/svg/campaign.svg'
import comment from '../../../assets/svg/CommentLarge.svg'
import report from '../../../assets/svg/ReportBig.svg'
import bg from '../../../assets/svg/bg.svg'
import CustomerClub from '../../../assets/svg/DashboardIconColorfull.svg'

import { useNavigate } from 'react-router-dom'
import { UserDate } from '../../../Data'
import { Link } from 'react-router-dom'

export default function index() {
  document.title = 'داشبورد باشگاه مشتریان'

  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate()

  const [chartData, setChartData] = useState({
    labels: UserDate.map((data) => data.yaer),
    datasets: [
      {
        label: 'فروش هفتگی',
        data: UserDate.map((data) => data.userGain),
        backgroundColor: ['#1B629D'],
      },
    ],
  })

  document.title = 'داشبورد'

  return (
    <main id='dashboard'>
      <Menu page={'dashboardCC'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='dashboardBody'>
        <section className='dashboardContent'>
          <div className='analytics'>
            <div className="moduleTitle">
              ماژول‌ها
            </div>
          </div>
          <div className="modules">
            <Link to='/dashboard'>
              <img style={{ width: '57px',padding: '1em' }} src={CustomerClub} alt="CustomerClub" />
              <hr />
              <section className='modulesText'>
                داشبورد
              </section>
            </Link>
          </div>
          <div className='analytics'>
            <div className='qrSection'>
              <div className='text'>
                <span>کیوآرکد</span>
                <span>QR Code</span>
              </div>
              <hr />
              <div className='qr'>
                <img src={qr} alt='qr' />
              </div>
              <hr />
              <div className='suggestText'>
                با استفاده از دوربین خود اسکن کنید
              </div>
            </div>
            <div className='lineChart'>
              
            </div>
          </div>

          <div className='crateSection'>
            <div className='resturant'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={campaign} alt='campaign' />
                <section className='text'>
                  ایجاد کمپین های مختلف
                </section>
              </div>
              <div className='down'>
                <button onClick={() => navigate('/cc/campaigns/create')}>
                  ایجاد
                </button>
                <Link to='/cc/campaigns' className='outlineLink'>
                  لیست کمپین‌ها
                </Link>
              </div>
            </div>
            <div className='category'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={comment} alt='comment' />
                <section className='text'>
                  مشاهده دیدگاه مشتریان
                </section>
              </div>
              <div className='down' style={{ padding: '24px' }}>
                <Link to='/cc/comments' className='outlineLink'>
                  لیست دیدگاه ها
                </Link>
              </div>
            </div>
            <div className='food'>
              <img src={bg} alt='bg' />
              <div className='up'>
                <img src={report} alt='report' />
                <section className='text'>
                  مشاهده گزارش ها
                </section>
              </div>
              <div className='down' style={{ padding: '24px' }}>
                <Link to='/cc/reports' className='outlineLink'>
                  لیست گزارش ها
                </Link>
              </div>
            </div>
          </div>

          <div className="statistics">
            <div className='card'>
              <div className='title'>
                تعداد کمپین ها :
              </div>
              <div className='value'>
                0 عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                دیدگاه های ثبت شده :
              </div>
              <div className='value'>
                0 عدد
              </div>
            </div>
            <div className='card'>
              <div className='title'>
                تعداد گزارش ها :
              </div>
              <div className='value'>
                0 عدد
              </div>
            </div>
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
